module.exports = __webpack_public_path__ + "static/media/disabled-arrow-right.f62f523e.svg";